import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type StreamerPlatform = 'twitch' | 'youtube' | 'kick' | 'tiktok' | 'other';

export interface StreamerItem {
    streamer_id?: number;
    name: string;
    platform: StreamerPlatform;
    url: string;
    discord_name: string;
    live_message: string;
    discord_channel: string;
    avatar: string;
    description: string;
    is_active: number;
    /** 1 for the league's main streamer – at most one entry has this set. */
    is_main: number;
    sort_order: number;
    created_at?: string;
}

/** Platform labels for dropdowns/tags – shared by every streamer UI. */
export const STREAMER_PLATFORM_OPTIONS: { label: string; value: StreamerPlatform }[] = [
    { label: 'Twitch', value: 'twitch' },
    { label: 'YouTube', value: 'youtube' },
    { label: 'Kick', value: 'kick' },
    { label: 'TikTok', value: 'tiktok' },
    { label: 'Sonstige', value: 'other' },
];

export function streamerPlatformLabel(platform?: StreamerPlatform | string | null): string {
    return STREAMER_PLATFORM_OPTIONS.find((o) => o.value === platform)?.label ?? platform ?? '';
}

@Injectable()
export class StreamerService {
    private apiUrl = `${environment.apiBaseUrl}/api/streamer.php`;

    constructor(private http: HttpClient) {}

    getAll(): Observable<StreamerItem[]> {
        return this.http.get<StreamerItem[]>(this.apiUrl);
    }

    /** The active main streamer, or null when none is set. */
    getMain(): Observable<StreamerItem | null> {
        return this.http.get<StreamerItem | null>(this.apiUrl, { params: { main: 1 } });
    }

    create(streamer: StreamerItem): Observable<StreamerItem> {
        return this.http.post<StreamerItem>(this.apiUrl, streamer);
    }

    update(streamer: StreamerItem): Observable<{ success: boolean }> {
        return this.http.put<{ success: boolean }>(this.apiUrl, streamer);
    }

    remove(streamer_id: number): Observable<{ success: boolean }> {
        return this.http.delete<{ success: boolean }>(this.apiUrl, { body: { streamer_id } });
    }
}
